<template>
  <div class="login-master">
    <div class="log-in-div">

      <div>
          <div class="input-wrap">
          <label for="mailInput">Корисничко име:</label>
          <input id="mailInput" type="text" v-model="emailInput" @keyup.enter="logIn">
        </div>
        <div class="input-wrap">
          <label for="passInput">Лозинка:</label>
          <input id="passInput" type="password" v-model="passwordInput" @keyup.enter="logIn">
        </div>
        <button @click="logIn">Пријави се</button>
      </div>
      
    </div>

    <div class="mars-logo">
      <a href="https://mars-server.net" target="_blank"><img src="../../public/MarsBlack.png" alt="Mars Logo"></a>
    </div>

    <error-msg 
    v-if="errorPopup" 
    :msgText="errorMsgToShow" 
    :fatal="isItFatalError"
    @close="errorPopup=false"/>

  </div>
</template>

<script>
import ErrorMsg from '../components/ErrorMsg'
import extraData from '../extraData.js'
import axios from 'axios'

export default {
  name: 'Login',
  components:{
    ErrorMsg
  },
  data(){
    return {
      emailInput: "",
      passwordInput: "",
      errorPopup: false,
      errorMsgToShow: "",
      isItFatalError: false
    }
  },
  methods:{
    logIn(){
      // console.log(this.emailInput, this.passwordInput)
      axios.post(extraData.adress+"login",{
        email: this.emailInput,
        pass: this.passwordInput
      }).then((res)=>{
        // console.log(res);
        if(res.data.res==='err'){throw res.data.msg}
        sessionStorage.setItem("sid", res.data.sid);
        sessionStorage.setItem("admin", res.data.admin);
        sessionStorage.setItem("userId", res.data.id);
        sessionStorage.setItem("projectsId", JSON.stringify(res.data.projects));
        if(res.data.admin){
          this.$router.push('/admin');
          return;
        }
        this.$router.push('/korisnik');
      }).catch((err)=>{
        // console.log(err);
        this.errorMsgToShow=err;
        this.errorPopup=true;
      })
    }
  }
}

</script>

<style lang="scss" scoped>
  .login-master{
    p{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      input{
        margin-left: auto;
      }
    }
    button{
      @include ButtonStyling();
      width: 100%;
      box-sizing: border-box;
    }
    .mars-logo{
      z-index: 1200;
      position: fixed;
      bottom: 0;
      right: 0;
      margin: 10px;
      >a>img{
        width: 200px;
      }
    }
  }

  .log-in-div{
    @include PopupStyling();
    background-color: transparent;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 40px;
  }

  .input-wrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
  }
  @media only screen and (max-width: 768px) {
    .log-in-div{
      padding: 0;
      >div{
        width: 100%;
        padding-left: 0;
        padding-right: 0;
      }
      button{
        display: block;
        width: 204.5px;
        margin: 30px auto 0;
      }
    }
    .input-wrap{
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 600px) {
    .login-master{
      .mars-logo{
        left: 30%;
        margin: 0;
        width: 100%;
        >a>img{
          width: 40%;
        }
      }
    }
  }
</style>
